<igx-grid #gridContactoClientes [width]="'100%'" [height]="'100%'" [locale]="localGrid"
  [allowFiltering]="true" [filterMode]="'excelStyleFilter'" [rowSelection]="activarBotones ? rowSelectionSingle : rowSelectionMultiple" [selectRowOnClick]="false" [sortingOptions]="sortingOptions"
  [rowEditable]="true" [primaryKey]="'IdClienteContacto'" (rowEditEnter)="rowEditEnter()" (rowEditExit)="rowEditExit()" (columnInit)="onColumnInit($event)"
  (rowEditDone)="addUpdateContactoCliente($event)" (rowEdit)="validarContactoCliente($event)" (contextMenu)="menuContextual($event)" (window:click)="disableContextMenu()"
  [moving]="true" (rowSelectionChanging)="handleRowSelection()">
  <igx-grid-toolbar>
    <igx-grid-toolbar-title>
      <app-filtro-general-moderno #filtroGeneral descripcionLabel="{{ 'MENSAJES.GRALS.ETIQUETA_FILTRO_GRAL' | translate}}" (enterPalabra)="filterInput($event)" (limpiarPalabras)="clearInput()" />
    </igx-grid-toolbar-title>
    <igx-grid-toolbar-actions>
      <igx-grid-toolbar-hiding />
      <igx-grid-toolbar-pinning />
      <app-mas-opciones-grid #masOpcionesG [arrayDatosAVer]="[0, 1, 2, 3, 6]" (opcionSeleccionada)="onSelectionDropDown($event)" />
    </igx-grid-toolbar-actions>
  </igx-grid-toolbar>
  <ng-template igxSortHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortAscendingHeaderIcon>
    <igx-icon>north</igx-icon>
  </ng-template>
  <ng-template igxSortDescendingHeaderIcon>
    <igx-icon>south</igx-icon>
  </ng-template>
  <ng-template igxExcelStyleHeaderIcon>
    <igx-icon>filter_alt</igx-icon>
  </ng-template>
  <igx-column field="NombreClienteContacto" header="{{ 'GRIDS.CONTACTO_CLIENTE.COL_CONTACTO' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true" [hasSummary]="true" [summaries]="'filasSummary' | summaryPipeNeo">
    <ng-template igxHeader #nombreClienteContactoHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CONTACTO_CLIENTE.COL_CONTACTO' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #nombreClienteContactoEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="NombreClienteContacto" [(ngModel)]="cell.editValue" uppercase [igxTextSelection]="true" [igxFocus]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="80"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="CargoClienteContacto" header="{{ 'GRIDS.CONTACTO_CLIENTE.COL_CARGO' | translate}}" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true">
    <ng-template igxHeader #cargoClienteContactoHeaderTemplate let-column>
      <div title="{{ 'GRIDS.CONTACTO_CLIENTE.COL_CARGO' | translate}}" class="header-required">{{column.header + '*'}}</div>
    </ng-template>
    <ng-template igxCellEditor #cargoClienteContactoEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="CargoClienteContacto" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="100"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="TelefonoClienteContacto" header="{{ 'GRIDS.CONTACTO_CLIENTE.COL_TELEFONO' | translate}}" [dataType]="'string'" width="110px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #telefonoClienteContactoEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="TelefonoClienteContacto" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="30"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <igx-column field="MailClienteContacto" header="Mail" [dataType]="'string'" width="120px" [sortable]="true" [resizable]="true">
    <ng-template igxCellEditor #mailClienteContactoEditorTemplate let-cell="cell">
      <igx-input-group>
        <input igxInput name="MailClienteContacto" [(ngModel)]="cell.editValue" [igxFocus]="true" [igxTextSelection]="true"
               (keydown)="stopPropagationPegado($event)" type="text" maxlength="50"/>
      </igx-input-group>
    </ng-template>
  </igx-column>
  <!--Acciones Editar, Agregar y Borrar-->
  @if (showActionStrip) {
    <igx-action-strip #actionstrip>
      <button title="{{ 'TOOLTIPS.NUEVO_REGISTRO' | translate}}" igxButton="fab" style="margin-right: 5px" (buttonClick)="accionStripRowBtn(actionstrip.context, 1)">
        <igx-icon>add</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.EDITAR_REGISTRO' | translate}}" igxButton="fab" igxRipple style="margin-right: 5px" (buttonClick)='startEdit(actionstrip.context)'>
        <igx-icon>edit</igx-icon>
      </button>
      <button title="{{ 'TOOLTIPS.BORRAR_REGISTRO' | translate}}" igxButton="fab" (buttonClick)="accionStripRowBtn(actionstrip.context, 2)">
        <igx-icon>delete</igx-icon>
      </button>
    </igx-action-strip>
  }
</igx-grid>
@if (verContextMenu) {
  <app-context-menu-generico [cellMenuContextual]="cellMenuContextaul" [menusOpciones]="menus" [lengthMenu]="lengthMenu"
                             (accionSeleccionada)="accionSeleccionada($event)" [x]="contextmenuX" [y]="contextmenuY" />
}
